import { Switch as AranduSwitch, SwitchProps as AranduSwitchProps } from '@ads/components-react';

import { cn } from '@/lib/utils';

interface SwitchProps extends AranduSwitchProps {}

const Switch = ({ ...props }: SwitchProps) => <AranduSwitch {...props} className={cn('w-max', props.className)} />;

export { Switch };
